export class Comparisons {
  static HasValue = 'HASVALUE';
  static IsEmpty = 'ISEMPTY';
  static IsNotOneOf = 'ISNOTONEOF';
  static IsOneOf = 'ISONEOF';
  static Contains = 'CONTAINS';
  static EqualTo = 'EQUALTO';
  static NotEqualTo = 'NOTEQUALTO';
  static LessThanOrEqualTo = 'LESSTHAN';
  static MoreThanOrEqualTo = 'MORETHAN';
  static DoesNotContain = 'DOESNOTCONTAIN';
}
